var React = require('react');

function Alarm (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM12.6,4.8v2.2c0,0.2,0.1,0.7,0.1,0.8l1,3.5c0.4,1.1-0.2,2.4-1.4,2.4H3.6c-1.2,0-1.8-1.3-1.4-2.4l1-3.5C3.3,7.7,3.4,7.3,3.4,7V4.8\n\t\tc0-1.7,0.7-2.3,2.2-2.9C6.3,1.6,7.2,0.5,8,0.5s1.6,1,2.2,1.2C11.8,2.4,12.6,3.2,12.6,4.8z","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM5.6,13.8c0,0.9,1.2,1.7,2.4,1.7c1.2,0,2.4-0.8,2.4-1.7","key":1})]));
}

Alarm.displayName = "Alarm";

Alarm.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Alarm;

Alarm.default = Alarm;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/alarm.svg
// module id = ../icon/src/icons/alarm.svg
// module chunks = 0